<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :model="form" class="user-search" label-width="100px" size="small">
      <el-row>
        <el-col :span="7">
          <el-form-item label="出库单号">
            <el-input size="small" v-model="form.outstockCode" placeholder="请输入出库单号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="出库类型">
            <el-select
                  v-model="form.outstockType"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择出库类型"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in outstockTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="出库时间">
                <el-select
                  v-model="form.aprovalCondition"
                  clearable
                  placeholder="请选择"
                  style="width: 120px;"
                  @change="updateApprovalChange('outstockTime')"
                >
                  <el-option
                    v-for="item in conditionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="form.aprovalCondition == 'between'"
                  key="0"
                  class="half-width"
                  v-model="form.outstockTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
                <el-date-picker
                  v-if="form.aprovalCondition !== 'between' && form.aprovalCondition !== 'auto'"
                  key="1"
                  class="half-width"
                  v-model="form.outstockTime"
                  type="datetime"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-select
                  v-model="form.outstockTime"
                  placeholder="请选择"
                  v-if="form.aprovalCondition == 'auto'"
                  class="half-width"
                  :class="{'w120':form.approvalValue == '7'}"
                  @change="dynamicUpdateValueChange"
                >
                  <el-option
                    v-for="item in dynamicDate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.outstockTime"
                  placeholder="请选择"
                  v-if="form.aprovalCondition == 'auto' && form.approvalValue == '7'"
                  style="margin-top: 8px;width: 120px;"
                >
                  <el-option
                    v-for="item in dateOneOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-tooltip content="只支持1-365的正整数">
                  <el-input-number
                    v-if="form.aprovalCondition == 'auto' && form.approvalValue == '7'"
                    @blur="dateInputUpdateBlur"
                    v-model="form.outstockTime"
                    step-strictly
                    controls-position="right"
                    :min="1"
                    :max="365"
                    style="margin-left: 8px;margin-top: 8px;width: 120px;"
                  ></el-input-number>
                </el-tooltip>
                <el-select
                  v-model="form.outstockTime"
                  placeholder="请选择"
                  v-if="form.aprovalCondition == 'auto'&& form.approvalValue == '7'"
                  style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);"
                >
                  <el-option
                    v-for="item in dateTwoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
          </el-form-item>

        </el-col>
        <el-col :span="3" class="text-align-right">
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-col>
        <div v-if="!isFold">
          <el-col :span="7" >
            <el-form-item label="备注">
              <el-input size="small" v-model="form.remark" placeholder="请输入备注" clearable></el-input>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
      <el-divider><i :class="!isFold?'el-icon-caret-top':'el-icon-caret-bottom'" @click="fold"></i></el-divider>
    </el-form>
  </div>
</template>
<script>
export default {
  props:['form'],
  data() {
    return {
      isFold:true,
      conditionOptions: [
        {
          value: "between",
          label: "选择范围"
        },
        {
          value: "lt",
          label: "小于"
        },
        {
          value: "lte",
          label: "小于等于"
        },
        {
          value: "eq",
          label: "等于"
        },
        {
          value: "gt",
          label: "大于"
        },
        {
          value: "gte",
          label: "大于等于"
        }
      ],
      dynamicDate: [{
        value: '0',
        label: '今天',
      }, {
        value: '1',
        label: '昨天'
      }, {
        value: '2',
        label: '本周'
      }, {
        value: '3',
        label: '上周'
      }, {
        value: '4',
        label: '本月'
      }, {
        value: '5',
        label: '上月'
      }, {
        value: '6',
        label: '近三月'
      }, {
        value: '7',
        label: '自定义'
      }],
      dateOneOptions:[{
        value: '过去',
        label: '过去'
      }, {
        value: '未来',
        label: '未来'
      }],
      dateTwoOptions:[{
        value: '日',
        label: '日'
      }, {
        value: '周',
        label: '周'
      }, {
        value: '月',
        label: '月'
      }, {
        value: '季度',
        label: '季度'
      }, {
        value: '年',
        label: '年'
      }],
      outstockTypeList: [ {
        label:'普通出库',
        value:'普通出库'
      },{
        label:'销售出库',
        value:'销售出库'
      },{
        label:'生产出库',
        value:'生产出库'
      },{
        label:'调拨出库',
        value:'调拨出库'
      },{
        label:'采购退货出库',
        value:'采购退货出库'
      },{
        label:'其它出库',
        value:'其它出库'
      }],
    }
  },
  methods: {
    updateApprovalChange: function(val) {
      this.$set(this.form, "approvalValue", "");
      this.$set(this.form, val, "");
    },
    // 自定义时 默认给1
    dynamicCreateValueChange:function(){
      if(this.form.dynamicCreateValue == '7'){
        this.$set(this.form,'dateCreateInput','1')
      }else{
        delete this.form.dateCreateInput
      }
    },
    dynamicUpdateValueChange:function(){
      if(this.form.dynamicUpdateValue == '7'){
        this.$set(this.form,'dateUpdateInput','1')
      }else{
        delete this.form.dateUpdateInput
      }
    },
    dateInputUpdateBlur:function(){
      if(this.form.dateUpdateInput == undefined){
        this.$set(this.form,'dateUpdateInput','1')
      }
    },
    dateInputCreateBlur:function(){
      if(this.form.dateCreateInput == undefined){
        this.$set(this.form,'dateCreateInput','1')
      }
    },
    search() {
      // this.getdata(this.form)
      this.$emit('search',this.form);
    },
    fold(){
      this.isFold = !this.isFold;
    },
    outstockTimeChange:function(){
      this.$set(this.form,'dynamicCreateValue','')
    },
    updateConditionChange:function(){
      this.$set(this.form,'dynamicUpdateValue','')
    },
  },
}
</script>
<style scoped>
.user-search {
  margin-top: 20px;
}
.normal-half-width{
  width: calc(100% - 132px);
  margin-left: 8px;
}
.el-divider__text{
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/stockManagement/outboundOrder/ListTop.vue